<script>
import baseInput from '../mixins/baseInput'

export default {
    name: 'InputTextarea',

    mixins: [baseInput],

    props: {
        maxHeight: {
            type: Number,
            default: undefined,
        },
        minHeight: {
            type: Number,
            default: undefined,
        },
        resize: Boolean,
        noBorder: Boolean,
        alignRight: Boolean,
        max: {
            type: Number,
            default: 255,
        },
    },
    data() {
        return {
            borderWidth: 0,
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputEl.value) this.textareaResize(this.$refs.inputEl)
            else this.$refs.inputEl.style.minHeight = this.minHeight
            this.borderWidth =
                parseInt(
                    window
                        .getComputedStyle(document.body)
                        .getPropertyValue('--input-border-width')
                        .replace('px', '') || 0
                ) * 2
        })
    },
    methods: {
        onInput(evt) {
            if (!this.disabled && !this.readonly) {
                this.$emit('input', evt.target.value)
            }
            this.textareaResize(this.$refs.inputEl)
        },
        isBetween(value, min, max) {
            return min <= value && value <= max
        },
        textareaResize(textarea) {
            if (
                textarea &&
                this.resize &&
                (!this.maxHeight || textarea.offsetHeight <= this.maxHeight) &&
                this.minHeight < textarea.scrollHeight + this.borderWidth &&
                !this.isBetween(
                    textarea.scrollHeight + this.borderWidth,
                    textarea.offsetHeight - 3,
                    textarea.offsetHeight + 2
                )
            ) {
                textarea.style.height = `${textarea.scrollHeight + this.borderWidth}px`
                textarea.scrollTop = textarea.offsetHeight
            }
        },
    },
}
</script>

<template lang="pug">
.form-group
    label(v-if="hasDefaultSlot" :for="uid" :data-disabled="disabled")
        slot
        sup(v-if="required") *
        small.length-validator(v-if="max") {{$t('base.max_length', {count: maxLength})}}
    textarea.form-control(
        ref="inputEl"
        :id="uid"
        :value="value"
        :required="required"
        :aria-label="placeholder"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="max"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        @change="onChange"
        @keypress.enter="onEnter"
        :style="{minHeight: `${minHeight}px`}"
        :class="{'border-0': noBorder, 'is-invalid': hasError, 'resize': resize, 'text-right': alignRight}"
    )
    .invalid-feedback(
        v-if="hasError"
        :class="{'cursor-pointer': needTooltip}"
        v-html="hintText"
        ref="feedback"
        v-tooltip.hover.bottom.html="needTooltip ? hintText : undefined")
</template>
